import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	content: {
		padding: SPACE[16],
		width: 340,
	},
});
